module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAQCAYAAADwMZRfAAAAyUlEQVQ4jeXSPWpCURDF8V8kZRYQlGAT7CKkSudHWpeQRiwF6yzCNl3atw4JbsAVqE/dhBAJaUaQx32+IHY5cJk7hzN/hsu9ybLMGT1jjg4WZaHaOQLquItaqirIn/QPIE9olOTraBfN20TwM8KvBf8RMyzRr9rkLeoXWnFvRf+DUXEgBVmihwOm4U3xHf46BckxLvirGNhFv0E3sqcaIq+hiYfERnmAPqJuE5l7NFMPe6oNJhWZ6/yT4yZ9vF8wPzhC9niJc4n2v//UHy489gvbAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/images/download_icon.png
// module id = h+dc
// module chunks = 0